


























import {Component, Prop, Vue} from "vue-property-decorator";
import {Location} from "vue-router";
import {literal} from "@/components/filters/Literal";
import {Agent} from "@/models/Agent";
import AgentRank from "@/components/AgentRank.vue";
import AgentAvatar from "@/components/AgentAvatar.vue";

@Component({
  components: {AgentAvatar, AgentRank},
  filters: {
    literal
  }
})
export default class Profile extends Vue {
  @Prop() public readonly agent!: Agent;
  @Prop({default: undefined}) public readonly link?: string | Location | undefined;
}
